var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningTriangleFilledOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 37,
    viewBox: "0 0 42 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.5312 31.5781C41.7812 33.7656 40.2188 36.5 37.6406 36.5H4.28125C1.70312 36.5 0.140625 33.7656 1.39062 31.5781L18.1094 3.14062C19.3594 0.953125 22.5625 0.953125 23.8906 3.14062L40.5312 31.5781ZM19.125 12.125V22.125C19.125 23.2188 20.0625 24 21 24C22.0156 24 22.875 23.2188 22.875 22.125V12.125C22.875 11.1094 22.0156 10.25 21 10.25C19.9062 10.25 19.125 11.1094 19.125 12.125ZM21 31.5C22.3281 31.5 23.4219 30.4062 23.4219 29.0781C23.4219 27.75 22.3281 26.6562 21 26.6562C19.5938 26.6562 18.5 27.75 18.5 29.0781C18.5 30.4062 19.5938 31.5 21 31.5Z",
    fill: "#DC6803"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningTriangleFilledOrange);
export default __webpack_public_path__ + "static/media/warning-triangle-filled-orange.c664d571a71702fc84f6060b73afa837.svg";
export { ForwardRef as ReactComponent };